// extracted by mini-css-extract-plugin
module.exports = {"section":"C2_section___XGje"};